import { SearchResult } from '../search-result.model';
import { BaseCaseSearchResultDto } from './base-case-search-result-dto.model';

export class CaseSearchResponseResult<T extends BaseCaseSearchResultDto> extends SearchResult<T> {
  public TotalLoanAmount?: number;
}
